import React from "react"
import { SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import { FormattedMessage, useIntl } from "react-intl"
import {
  Box,
  Link,
  Tile,
  Typography,
  Stack,
  useTheme,
  IconWithBackground,
  CircleQuestionMarkIcon
} from "@carrotfertility/carotene-core"
import { Link as ReactRouterLink } from "react-router-dom"
import { getSupportCenterLink, goToHelpCenter } from "carrot-api/HelpCenterClient"

export function SidebarHelp(): JSX.Element {
  const intl = useIntl()
  const theme = useTheme()
  return (
    <Tile
      variant="secondary"
      color="green"
      sx={(theme) => ({
        display: "flex",
        padding: theme.spacing(theme.tokens.spacing.lg),
        marginBlockEnd: theme.spacing(theme.tokens.spacing.lg)
      })}
    >
      <Stack sx={{ gap: theme.spacing(theme.tokens.spacing.md) }}>
        <Stack direction="row" alignItems="center" gap={theme.spacing(theme.tokens.spacing.md)}>
          <IconWithBackground icon={CircleQuestionMarkIcon} color="green" />
          <Typography variant="body1" color="secondary" fontWeight="bold">
            <FormattedMessage defaultMessage="Can we help?" />
          </Typography>
        </Stack>
        <Box display="flex" flexDirection="column" gap={(theme) => theme.spacing(theme.tokens.spacing.sm)}>
          <Link
            to="/talk-to-carrot/sendmessage/helpfindingprovider"
            color="inherit"
            variant="body2"
            component={ReactRouterLink}
            title={intl.formatMessage({ defaultMessage: "Contact us about finding a provider" })}
          >
            <FormattedMessage defaultMessage="Contact us" />
          </Link>
          <Link
            color="inherit"
            variant="body2"
            href={getSupportCenterLink(SupportCenterLinks.CARROT_PROVIDERS)}
            onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
              goToHelpCenter(event, SupportCenterLinks.CARROT_PROVIDERS)
            }
            target={"_blank"}
            title={intl.formatMessage({ defaultMessage: "Learn more about Carrot providers" })}
          >
            <FormattedMessage defaultMessage="Learn more" />
          </Link>
        </Box>
      </Stack>
    </Tile>
  )
}
